import MalekiLogo from "../../../../assets/images/maleki/logo.png";
import {MdOutlineFastfood} from "react-icons/md";
import {SiHotjar} from "react-icons/si";
import {CiDiscount1} from "react-icons/ci";
import {AiOutlineExclamationCircle} from "react-icons/ai";
import {AiOutlineQuestionCircle} from "react-icons/ai";
import {SiSellfy} from "react-icons/si";
import {BsCircleFill} from "react-icons/bs";
import MenuAccordion from "./MenuAccordion";
import {CgClose} from "react-icons/cg";
import {useState} from "react";
import "./menudrawer.scss";
import {NavLink} from "react-router-dom"
import ekia from "../../../../assets/images/ekia.png";

const MenuDrawer = ({setShowMenu}) => {
    return (
        <div className="menus_drawer">
            <div className="d-flex justify-content-between align-items-center">
                <NavLink to="/" className="menu_Drawer-logo " onClick={() => {
                    setShowMenu(false)
                }}>
                    <img src={ekia} alt="MalekiLogo" className="fa_logo"/>
                </NavLink>
                <div
                    className="d-flex justify-content-end cursor-pointer mx-3"
                    onClick={(e) => {
                        setShowMenu(false);
                    }}
                >
                    <CgClose></CgClose>
                </div>
            </div>
            <div className="menu_Drawer_items mb-4">
                <div className="menu_drawer-itemsbox mt-3">
                    <div className="menu_drawer-item"
                        // document.getElementById("footer-container").scrollIntoView({block:"nearest",behavior:"smooth"})
                    >
                        <BsCircleFill size={10}/>
                        <span className="cursor-pointer"
                              onClick={() => {
                                  setShowMenu(false);
                                  if (document.getElementById("box-store") != null) {
                                      document
                                          .getElementById("box-store")
                                          .scrollIntoView({behavior: "smooth", block: "nearest"});
                                  } else {
                                      window.location.href = "/category/0"
                                  }
                              }}>فروشگاه</span>
                    </div>
                    {/* <div className="menu_drawer-item">
             <AiOutlineExclamationCircle size={22} color="#9e9fb1" />
            <BsCircleFill size={10} />
            <span>شگفت انگیز ها</span>
          </div>  */}
                    {/* <div className="menu_drawer-item">
            <AiOutlineQuestionCircle size={22} color="#9e9fb1" />
            <BsCircleFill size={10} />
            <span>درباره ما</span>
          </div>  */}
                    <div className="menu_drawer-item">
                        {/* <CiDiscount1 size={22} color="#9e9fb1" /> */}
                        <BsCircleFill size={10}/>
                        <NavLink className="ps-2 digi_menus-link text-decoration-none" onClick={() => {
                            setShowMenu(false)
                        }}
                                 to="/blog">
                  <span>
                  بلاگ / مجله
                  </span>
                        </NavLink>
                    </div>

                    <div className="menu_drawer-item"
                        // document.getElementById("footer-container").scrollIntoView({block:"nearest",behavior:"smooth"})
                    >
                        <BsCircleFill size={10}/>
                        <span className="cursor-pointer"
                              onClick={() => {
                                  setShowMenu(false);
                                  document.getElementById("footer-container").scrollIntoView({
                                      behavior: "smooth",
                                      block: "nearest"
                                  })
                              }}>تماس با ما</span>
                    </div>

                    <div className="menu_drawer-item">
                        {/* <CiDiscount1 size={22} color="#9e9fb1" /> */}
                        <BsCircleFill size={10}/>
                        <NavLink className="ps-2 digi_menus-link text-decoration-none" onClick={() => {
                            setShowMenu(false)
                        }}
                                 to="/blog/post/1">
                  <span>
                 ضمانت و شرایط بازگشت کالا و وجه
                  </span>
                        </NavLink>
                    </div>
                </div>
            </div>
            <div className="menu_drawer-categorys mb-3">
                <span className="menu_d-category-title">دسته بندی کالاها</span>
            </div>
            <div className="menu_drawer-category">
                <MenuAccordion setShowMenu={setShowMenu}/>
            </div>
        </div>
    );
};

export default MenuDrawer;
